import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_043.jpg';
page.games = [
  {
    id: 'page043_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1762,
    },
    item: {
      id: 'page043_game10',
    },
    rectangle: {
      id: 'page043_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page043_rect0',

    tooltip: '',

    linked: ['page043_game10'],
    x: 139,
    y: 1762,
    width: 452,
    height: 460,
  },
];
page.images = [
  {
    imageId: 'page043_zoom0',
    rectangle: {
      x: 600,
      y: 1788,
      width: 1040,
      height: 672,
    },
    imageSrc: 'images/page043/043 1.jpg',
  },
  {
    imageId: 'page043_zoom1',
    rectangle: {
      x: 978,
      y: 832,
      width: 792,
      height: 538,
    },
    imageSrc: 'images/page043/043 6.jpg',
  },
  {
    imageId: 'page043_zoom2',
    rectangle: {
      x: 150,
      y: 824,
      width: 794,
      height: 546,
    },
    imageSrc: 'images/page043/043 5.jpg',
  },
  {
    imageId: 'page043_zoom3',
    rectangle: {
      x: 1320,
      y: 194,
      width: 320,
      height: 608,
    },
    imageSrc: 'images/page043/043 4.jpg',
  },
  {
    imageId: 'page043_zoom4',
    rectangle: {
      x: 744,
      y: 198,
      width: 560,
      height: 602,
    },
    imageSrc: 'images/page043/043 3.jpg',
  },
  {
    imageId: 'page043_zoom5',
    rectangle: {
      x: 148,
      y: 196,
      width: 564,
      height: 606,
    },
    imageSrc: 'images/page043/043 2.jpg',
  },
];
export default page;
